import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Timeline from 'components/base/Timeline';
import {
  ActivityTimelineData,
  fetchActivityCallingTimelineData
} from 'data/activityTimelineData';
import { Col, Row } from 'react-bootstrap';

const CallingActivityTimeline: React.FC = () => {
  const [data, setData] = useState<ActivityTimelineData[]>([]);

  const fetchData = async () => {
    try {
      const timelineData = await fetchActivityCallingTimelineData();
      setData(timelineData);
    } catch (error) {
      console.error('Error fetching timeline data:', error);
    }
  };

  useEffect(() => {
    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 15000); // Actualizar cada 15 s

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar
  }, []);

  return (
    <Timeline variant="vertical">
      {data.map((item, index) => (
        <Timeline.Item className="position-relative" key={item.id}>
          <Row className="g-md-3">
            <Col
              xs="auto"
              sm="auto"
              xl="auto"
              xxl="auto"
              className="d-flex me-0 pe-0"
            >
              <Timeline.Separator className="position-md-relative me-1">
                <Timeline.Dot className="bg-secondary-subtle">
                  <FontAwesomeIcon
                    icon={item.separator.icon}
                    className="text-primary-dark fs-9"
                  />
                </Timeline.Dot>
                {index !== data.length - 1 && (
                  <Timeline.Bar className="h-100 border-dashed" />
                )}
              </Timeline.Separator>
            </Col>
            <Col>
              <Timeline.Content className="px-0">
                <p className="fs-10 fw-semibold text-body-tertiary text-opacity-85 lh-sm">
                  {item.oppositeContent.date} {item.oppositeContent.time}
                  <br className="lh-1" />
                  <span className="fs-9 p-0 mb-0 text-body-emphasis fw-bold">
                    {item.content.title}
                  </span>
                  <br className="lh-1" />
                  <span className="fs-9 p-0">
                    by{' '}
                    <span className="fs-9 mt-0 text-primary-dark">
                      {item.content.username}
                    </span>
                    <br />
                    <span className="fs-9">{item.content.description}</span>
                  </span>
                </p>
              </Timeline.Content>
            </Col>
          </Row>
        </Timeline.Item>
      ))}
    </Timeline>
  );
};

export default CallingActivityTimeline;
